﻿import { Injectable } from '@angular/core';
import { SessionService } from '../session/shared/session/session-service/session.service';
import { DashboardApi } from '../../../../../generated/internalApi/api/DashboardApi';
import { DashboardData, DashboardResponse } from '../../models';
import { Cache } from '../cache.service';

@Injectable()
export class DashboardDataCache extends Cache<DashboardData> {

  constructor (
    private sessionService: SessionService,
    private dashboardApi: DashboardApi) {
    super();
  }

  public populate(): void {
    const token = this.sessionService.data.authData.token;
    const mortgagePrimaryBorrowerData = this.sessionService.mortgageSession.data.borrowerData.primaryBorrowerData;
    const mortgageBorrowerGuid = mortgagePrimaryBorrowerData.borrowerGuid;
    const personalBorrowerGuid = this.sessionService.personalLoanSession.data.borrowerData.borrowerGuid;

    const onSuccess = (data: DashboardData) => {

      // Ensure that we attempt to populate the primaryBorrowerId since it's needed to display the
      // first and last name near the avatar navigation, etc.
      try {
        /**
         * Use Case: prior to the 'if' statement, we were brute forcing user
         * display name to primary borrower; setting borrowerId (which emits an
         * event and header component is listening to that change). Now, when
         * spouse logged in and identified themselves using the verify-ssn flow,
         * this brute force still showed the primary user name. In the verify
         * ssn flow, we are setting 'primaryBorrowerSelected' flag, so using it
         * here to guard brute force.
         */
        if (!this.sessionService.mortgageSession.data.borrowerData.primaryBorrowerSelected && !mortgagePrimaryBorrowerData.borrowerId) {
          mortgagePrimaryBorrowerData.borrowerId = (!!data.loans[0] ? data.loans[0].borrowers[0].borrowerID : '');
        }
      } catch (e) {
        console.error(e);
      }

      this.subject.next(data);
    };

    this.dashboardApi.dashboardGetDashboard(
      token,
      mortgageBorrowerGuid || undefined,
      personalBorrowerGuid || undefined
    )
    .map((response: DashboardResponse) => response.data)
    .subscribe(
      onSuccess,
      err => console.error(err),
      () => this.subject.complete()
    );
  }
}
